import { useState } from "react";
import { toast } from "sonner";
import { LogIn, Loader2 } from "lucide-react";
import BrandLogo from "@/components/BrandLogo.jsx";
import { authedAxios, formatApiErrorDetail } from "./api.js";

const inputCls =
  "w-full rounded-xl border border-zinc-200 bg-white px-4 py-3 text-sm outline-none transition-all focus:border-brand focus:ring-4 focus:ring-brand/10";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await authedAxios.post("/auth/login", { email, password });
      onLogin(data);
      toast.success("Welcome back!");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-tint/60 px-4" data-testid="admin-login-view">
      <form
        onSubmit={submit}
        className="w-full max-w-md rounded-3xl border border-zinc-100 bg-white p-8 shadow-[0_24px_70px_rgba(7,58,30,0.12)] sm:p-10"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-4">
          <span className="flex items-center justify-center">
            <BrandLogo size={48} rounded="rounded-2xl" fallbackBg="bg-brand" testid="admin-login-logo" />
          </span>
          <div>
            <h1 className="font-display text-2xl text-brand">Admin Dashboard</h1>
            <p className="text-xs text-zinc-500">Angukumaran Farmhouse website manager</p>
          </div>
        </div>

        <div className="mt-8 space-y-4">
          <div>
            <label className="mb-2 block text-[11px] font-semibold uppercase tracking-[0.16em] text-brand" htmlFor="admin-email">
              Email
            </label>
            <input
              id="admin-email"
              type="email"
              required
              className={inputCls}
              placeholder="admin@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="mb-2 block text-[11px] font-semibold uppercase tracking-[0.16em] text-brand" htmlFor="admin-password">
              Password
            </label>
            <input
              id="admin-password"
              type="password"
              required
              className={inputCls}
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={busy}
          className="mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-brand py-3.5 text-sm font-semibold uppercase tracking-[0.16em] text-white transition-all duration-300 hover:bg-brand-deep disabled:opacity-70"
          data-testid="admin-login-submit"
        >
          {busy ? <Loader2 size={17} className="animate-spin" /> : <LogIn size={17} />}
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
};
